import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FilterOption, FilterSection } from '../../pages/activities/types';

export type SortOptions = Array<{
  label: string,
  value: string,
}>;

@Component({
  selector: 'action-bar-header',
  templateUrl: 'action_bar_header.html',
})
export class ActionBarHeader {
  @Input() sortOptions: SortOptions;
  @Input() sortAsc: boolean;
  @Input() sortField: string;
  @Input() numFilters: number;
  @Input() callsRunning: Array<any>;
  @Input() filterSections: FilterSection[];
  @Input() getSortValueLabel: Function;
  @Input() filterText: string;
  @Output() onToggleSortOrder = new EventEmitter();
  @Output() onChangeSortField = new EventEmitter();
  @Output() onShowTextFilter = new EventEmitter();
  @Output() onShowFilterMenu = new EventEmitter();
  @Output() onClearFilters = new EventEmitter();
  @Output() onClearSearch = new EventEmitter();

  constructor() {
  }
  showFilterMenu() {
    this.onShowFilterMenu.emit();
  }
  toggleSortOrder() {
    this.onToggleSortOrder.emit();
  }
  changeSortField(newValue: string) {
    this.onChangeSortField.emit(newValue);
  }
  showTextFilter() {
    this.onShowTextFilter.emit();
  }
  clearFilters() {
    this.onClearFilters.emit();
  }
  clearSearch() {
    this.onClearSearch.emit();
  }
}



// WEBPACK FOOTER //
// ./src/directives/action_bar_header/action_bar_header.component.ts